var s = {};

s.alignItemsCenter = {
  alignItems: 'center',
  msFlexAlign: 'center',
  WebkitAlignItems: 'center'
};

s.alignSelfFlexStart = {
  alignSelf: 'flex-start',
  msFlexAlign: 'flex-start',
  WebkitAlignSelf: 'flex-start'
};

s.alignSelfStretch = {
  alignSelf: 'stretch',
  msFlexItemAlign: 'stretch',
  WebkitAlignSelf: 'stretch'
};

s.flex1 = {
  flex: 1,
  WebkitFlex: 1
};

s.flexDirectionRow = {
  flexDirection: 'row',
  msFlexDirection: 'row',
  WebkitFlexDirection: 'row'
};

s.flexWrapWrap = {
  flexWrap: 'wrap',
  msFlexWrap: 'wrap',
  WebkitFlexWrap: 'wrap'
};

s.justifyContentSpaceBetween = {
  justifyContent: 'space-between',
  msFlexPack: 'justify',
  WebkitJustifyContent: 'space-between'
}

module.exports = s;
